import { createAction } from 'redux-actions';
import { GallectionSortOrder, GallectionType } from '../../types/gallection';
import { SectionViewType } from '../../types/sections';

export const setSortOrder = createAction<GallectionSortOrder>(
  'GALLECTION_SECTION/SET_SORT_ORDER'
);

export const setViewType = createAction<SectionViewType>(
  'GALLECTION_SECTION/SET_VIEW_TYPE'
);

export const setGallectionSectionType = createAction<GallectionType>(
  'GALLECTION_SECTION/SET_GALLECTION_SECTION_TYPE'
);

export const setSelectedFolderId = createAction<number>(
  'GALLECTION_SECTION/SET_SELECTED_FOLDERID'
);

export const unsetSelectedFolderId = createAction(
  'GALLECTION_SECTION/UNSET_SELECTED_FOLDERID',
  () => ({})
);

export const setSelectedSubfolderId = createAction<number>(
  'GALLECTION_SECTION/SET_SELECTED_SUBFOLDERID'
);

export const unsetSelectedSubfolderId = createAction(
  'GALLECTION_SECTION/UNSET_SELECTED_SUBFOLDERID',
  () => ({})
);

export const setCurrentlyViewedFolderId = createAction<number>(
  'GALLECTION_SECTION/SET_CURRENTLY_VIEWED_FOLDERID'
);

export const unsetCurrentlyViewedFolderId = createAction(
  'GALLECTION_SECTION/UNSET_CURRENTLY_VIEWED_FOLDERID',
  () => ({})
);

export const setSearchInputValue = createAction<string>(
  'GALLECTION_SECTION/SET_SEARCH_INPUT_VALUE'
);

export const setSearchQuery = createAction<string>(
  'GALLECTION_SECTION/SET_SEARCH_QUERY'
);

export const clearSearch = createAction(
  'GALLECTION_SECTION/CLEAR_SEARCH',
  () => ({})
);

export const addFolderToFullViewList = createAction<number>(
  'GALLECTION_SECTION/ADD_FOLDER_TO_FULLVIEW_VIEW'
);

export const setFullViewFolderIds = createAction<number[]>(
  'GALLECTION_SECTION/SET_FULLVIEW_FOLDERIDS'
);

export const pauseCurrentFolderDeviationFetching = createAction(
  'GALLECTION_SECTION/PAUSE_CURRENT_FOLDER_DEVIATION_FETCHING',
  () => ({})
);

export const fetchAllFolders = createAction(
  'GALLECTION_SECTION/FETCH_ALL_FOLDERS',
  () => ({})
);
